/**
 * Created by pandemio on 12/19/18.
 */
/**
 * Created by portiz on 12/19/2018.
 */
import React from 'react';
import {Card, CardFooter, Col, Input, Button, CardHeader, Row} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../../translations/global.json"
/** End of Multiple Language imports **/

import LanguageManager from '../../custom-classes/language-manager';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCommentAlt} from '@fortawesome/free-solid-svg-icons';

/**
 * The chatbox for chat online assistance
 */
class ChatBox extends React.Component {

    constructor(props) { // start with a constructor if we want to do modifications on events
        super(props); // Super is required.

        const {chatHistory} = props;

        // Declare the properties and set the value according to what we are going to manage in the the page
        this.state = {
            client: props.socket,
            chatroomChosen: null,
            input: '',
            chatHistory,
            user: null,
            chatRoomAvailable: false,
            clientSide: typeof props.clientSide !== 'undefined' ? props.clientSide : false,
            smallDevice: false
        };

        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage()}
        });
        this.props.addTranslation(global);

        this.onInput = this.onInput.bind(this);
        this.onSendMessage = this.onSendMessage.bind(this);
        this.onMessageReceived = this.onMessageReceived.bind(this);
        this.updateChatHistory = this.updateChatHistory.bind(this);
        this.scrollChatToBottom = this.scrollChatToBottom.bind(this);

    }

    /** action when entering to the chat room. It takes the chat history **/
    onEnterChatroom(chatroomName) {
        return this.state.client.join(chatroomName, (err, chatHistory) => {
            if (err)
                return console.error(err);
            this.setState({chatHistory: chatHistory});
        })
    }

    /** Evaluate the resize, to show the proper navbar menu style*/
    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.state.client.registerHandler(this.onMessageReceived);
        this.scrollChatToBottom();
        this.resize();

    }

    resize() {
        this.setState({smallDevice: window.screen.width <= 500});
    }

    /** When te component receive props **/
    componentWillReceiveProps(nextprops){
        // If the chatroom is different from the actual chatroom
        if(this.state.chatroomChosen !== nextprops.chatroom)
        {
            this.setState({
                chatroomChosen: nextprops.chatroom,
                chatRoomAvailable: true
            },()=>{
                this.onEnterChatroom(this.state.chatroomChosen, this.state.user, null);
            });
        }
    }

    /** Action when the component updates **/
    componentDidUpdate() {
        this.scrollChatToBottom();
    }

    /** Component when unmounting **/
    componentWillUnmount() {
        this.state.client.unregisterHandler();
    }

    /**
     * When the input is made
     * @param e
     */
    onInput(e) {
        this.setState({
            input: e.target.value
        });
    }

    /**
     * Sends the message to the socket io.
     */
    onSendMessage() {
        if (!this.state.input)
            return;

        this.state.client.message(this.state.chatroomChosen, this.state.input, (err)=>{
            if (err) {
                this.setState({chatRoomAvailable: false, input: ''});
                return;
            }

            return this.setState({ input: '' });
        });
    }

    /**
     * Function when the message is received
     * @param entry
     */
    onMessageReceived(entry) {
        this.updateChatHistory(entry);
    }

    /**
     * Updates the chat history with the new entry
     * @param entry
     */
    updateChatHistory(entry) {
        this.setState({ chatHistory: this.state.chatHistory.concat(entry) });
    }

    /**
     * Scroll
     */
    scrollChatToBottom() {
        this.messagesEnd.scrollTop = this.messagesEnd.scrollHeight;
    }

    /**
     * Renders the main form element
     * @returns {XML}
     */
    render() {

        let chatClassName = '';
        if(this.state.clientSide && this.state.smallDevice)
            chatClassName = 'chat-mobile-size';
        else if(this.state.clientSide && !this.state.smallDevice)
            chatClassName = 'chat-max-height';
        return (
            <div>
                <Card className={chatClassName}>
                    <CardHeader>{this.state.chatroomChosen}</CardHeader>

                        <div className="card-body scrollable-card" ref={(el) => { this.messagesEnd = el; }}>
                            {
                                typeof this.state.chatHistory !== 'undefined' ?
                                this.state.chatHistory.map(
                                    ({ user, message, event, dateTime }, i) => [
                                            <div
                                                key={i}
                                                style={{ color: '#000' }}
                                                >
                                                <span className="gray-dark-text"><b>{`${user.substring(0, user.lastIndexOf(' '))} ${event || ''}`}</b></span>
                                                <br/>
                                                <span>{message &&  message }</span>
                                                <br/>
                                                <small className="gray-bright-text">{dateTime}</small>
                                                <hr/>
                                            </div>
                                    ]
                                ) : null
                            }
                        </div>

                    <CardFooter>
                        <Row>
                            <Col lg={{size: 12}} md={{size:12}} sm={{size:12}} xs={{size:12}}>
                                <small><Translate id="chat.enter-a-message" options={{renderInnerHtml: true}}/></small>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={{size: 10}} md={{size:10}} sm={{size:10}} xs={{size:10}}>
                                <Input type="textarea" placeholder="..." value={this.state.input}  onChange={this.onInput}
                                       onKeyPress={e => (e.key === 'Enter' ? this.onSendMessage() : null)}  disabled = {(!this.state.chatRoomAvailable)? "disabled" : ""}
                                />
                            </Col>
                            <Col lg={{size: 2}} md={{size:2}} sm={{size:2}} xs={{size:2}}>
                                <Button  color="success" onClick={this.onSendMessage}>
                                    <FontAwesomeIcon icon={faCommentAlt}/>
                                </Button>
                            </Col>
                        </Row>

                    </CardFooter>
                </Card>
            </div>
        )
    }
}

export default withLocalize(ChatBox);